module.exports = __webpack_public_path__ + "img/4.066766a3.jpg";